/// <summary>
/// This object provides js functions for showing error-code based tasks for one single signal <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 5.6.2024<br />
/// Copyright ©: EUDT GmbH 2024 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 5.6.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.SingleLog", jQuery.common.vcBaseV4, {
    popup: null,
    _create: function () {
        this._createVisual(362); 
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".error-single-log");
            me.myStatus.dateRange = { from: moment().format("DD.MM.YYYY"), to: moment().format("DD.MM.YYYY") } 
         
            if (me.specific.noData) { return true; }

            me._buildHtml();

            me._setHeights();



        } catch (e) {
            me._writeErr(e);
            return false;
        }
        return true;
    },




    _initEvents: function () {
        var me = this;
        try {
            if (me.specific.noData) { return true; }

            //me._initTriggers();

            // initialize the date and task box
            me._initStructure();

            me._fetch();


        } catch (e) {
            me._writeErr(e);
            return false;
        }
        return true;
    },



    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = { menu: {}, filter: {}, list: {}  };
         

            let obj = me.myHtml.menu;
            obj.wrapper = me._setWrapper("", "");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.date = me._setObj("date","optionbox vc-grid-2col float-box");
            obj.wrapper.append(obj.reload, obj.date);

            obj = me.myHtml.filter;
            obj.wrapper = me._setWrapper("", "");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");
            obj.wrapper.append(obj.filter);


            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w20").html(me.specific.resources.date));
            line.column.append(me._setListElement("", "w80").html(me.specific.resources.text));
            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table");
            obj.wrapper.append(obj.header, obj.entries);

         
            me.myRoot.append(me.myHtml.menu.wrapper,  me.myHtml.filter.wrapper, me.myHtml.list.wrapper);

        } catch (e) {
            me._writeErr(e);
            return false;
        }
        return true;
    },


    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            //we start with the last day we found any entries
            var day = moment(me.specific.lastTimestamp).format("DD.MM.YYYY");

            //init vcDate 
            me.myHtml.menu.date.vcDateBox({ mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: { from: day, to: day }, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } });

            //init reload button
            me.myHtml.menu.reload.off("click").on("click", function () { me._fetch(); });

            //init vc-filter
            me.myHtml.filter.filter.vcFilter({ callback: function () { me._filter(); } });

        } catch (e) { me._writeErr(e); }
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);

            var param = { TypeId: 1, StartDate: me.myStatus.dateRange.from, EndDate: me.myStatus.dateRange.to }
            me.getData(param, function (result) {
              
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
             
                me.myData = result;
                if (me.myData.content.length == 0) {
                    me.myHtml.left.text.html("nix data");
                }
                me._generateList();
              
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },




    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
 
            if (me.myData.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            // fill entry list
            $.each(me.myData, function (key, row) { me.myHtml.list.entries.append(me._fillRow(row)); });

            me._filter();

            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            //mark all lines with no bsaid - they are hardware-based
            var text = row.Text;
            if (row.Bsaid <= 0) { text = "*** " + text + " ***"; }

            var line = me._setListItem();
            line.column.append(me._setListElement("", "w20").html(moment(row.Timestamp).format("DD.MM.YYYY HH:mm:ss")));
            line.column.append(me._setListElement("", "w80").html(text));
            return line.item;
        } catch (e) { me._writeErr(e); return false; }
    },

    _filter: function () {
        //simplify function call only
        
        this._doListTableFilter(this.myHtml.list.entries);
    },

    _setHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
          
            var hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight() - me.myHtml.filter.wrapper.outerHeight();

            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height",hList);

        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.list.wrapper.hide();
                me.myHtml.menu.wrapper.hide();
            }
            return true;
        } catch (e) {
            me._writeErr(e); return false;
        }
    }
});